import { DEFAULT_LANDING_PAGE_ACCENT_COLOR } from '@consts';
import { usePaymentAndOrder } from '../../payments/PaymentAndOrderContext';
import LandingPagePreviewVideo from './LandingPagePreviewVideo';
import { isSectionHidden } from './landingPageSections';

export default function GoalLandingPagePreviewVideoSection() {
  const { state } = usePaymentAndOrder();
  const landingPage = state.goal?.landingPage;

  if (isSectionHidden(landingPage?.previewVideo)) return <></>;

  return (
    <LandingPagePreviewVideo
      previewVideo={landingPage?.previewVideo}
      accentColor={landingPage?.accentColor || DEFAULT_LANDING_PAGE_ACCENT_COLOR}
    />
  );
}
